import styled from 'styled-components';
import { AppStyledProps } from '../../../../../types';

type T = AppStyledProps & { src?: string };

export const IconStyled = styled.img.attrs<T>((props) => ({
  src: props.src || '/experience/winner.svg',
}))`
  fill: white;
  width: 9em;
`;
